import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/opt/build/repo/layouts/app.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  site: defineAsyncComponent(() => import("/opt/build/repo/layouts/site.vue").then(m => m.default || m))
}